import styles from "./css/Footer.module.css";

function Footer() {
    return (
        <>
            <div style={{ marginBottom: "20px" }}></div>
            <footer className={styles.footer}>
                <div className={styles.footer_content}>
                    <div className={styles.footer_section}>
                        <h3 className={styles.footer_heading}>Contact Us</h3>
                        <p>Email: tnebbeea@gmail.com</p>
                        <p>Phone: +91 9876543210</p>
                        <p>Address: 144, Anna Salai, Chennai, 600002</p>
                    </div>
                    <div className={styles.footer_section}>
                        <h3 className={styles.footer_heading}>Quick Links</h3>
                        <ul className={styles.footer_links}>
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/contact">Contact</a></li>
                            <li><a href="/forms">Forms & Manuals</a></li>
                        </ul>
                    </div>
                    <div className={styles.footer_section}>
                        <h3 className={styles.footer_heading}>Follow Us</h3>
                        <p>
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a> | 
                            <a href="https://x.com/BEEA_TNEB" target="_blank" rel="noopener noreferrer"> X (Twitter)</a> | 
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"> Instagram</a>
                        </p>
                    </div>
                </div>
                <div className={styles.footer_bottom}>
                    <p>&copy; 2025 Bharathiya Electricity Engineers Association. All rights reserved.</p>
                </div>
            </footer>
        </>
    );
}

export default Footer;